import { GenericLazyString } from '@eventbrite/i18n';
import React from 'react';

const AuthNotificationExtra = ({
    extraMessage,
}: {
    extraMessage?: GenericLazyString | string;
}) => {
    let extraMessageComponent = null;

    if (extraMessage) {
        extraMessageComponent = (
            <span
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: extraMessage.toString(),
                }}
            />
        );
    }

    return extraMessageComponent;
};

export default AuthNotificationExtra;
